module.exports = __webpack_public_path__ + "static/18-mission2-success-dabc7ca0f8c0d9271a03a42784137b90.png";